module.exports = __webpack_public_path__ + "static/media/1019736.f2e068ea.jpg";